import { render, staticRenderFns } from "./IconFamily.vue?vue&type=template&id=f753ecb2&scoped=true&"
import script from "./IconFamily.vue?vue&type=script&lang=js&"
export * from "./IconFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f753ecb2",
  null
  
)

export default component.exports